import { MessageBox, Loading } from 'element-ui';
import { Promotion_website_service } from "../services/Promotion_website_service";
import moment from "moment";
const { Parser } = require('json2csv');

const state = {
    promotions : [],
    data_table : [],
    providers : [],
    total : 0,
    loading : false,
    download_form: null,
    fields : [{
        label: 'ชื่อรายการส่งเสริมการขาย',
        value: 'promotion_name'
      }, {
        label: 'ชนิดของการให้บริการ',
        value: 'category'
      }, {
        label: 'ประเภทของการให้บริการ',
        value: 'type'
      }, {
        label: 'ราคา',
        value: 'promotion_price'
      }, {
        label: 'ผู้ให้บริการ',
        value: 'provider_name'
      }, {
        label: 'สถานะการตรวจสอบ',
        value: 'status'
      }, {
        label: 'เว็บไซต์',
        value: 'website_url'
      }, {
        label: 'วันที่จัดเก็บข้อมูล',
        value: 'created_at'
      }]
};

const actions = {
    async find_promotion({commit},filter){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        commit('SET_FORM_DOWNLOAD',filter)
        let result = await Promotion_website_service.find_promotion(filter)
        if(result.status === 200){
            commit('SET_STORAGE_DATA',result.data)
            commit('SET_LOADING',false)
            setTimeout(function(){ loadingInstance.close() }, 250);
        }else{
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })        
        }
    },

    async download_promotion({commit},filter){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        filter.download = true
        let result = await Promotion_website_service.find_promotion(filter)
        if(result.status === 200){
            let end = result.data.length
            let tmp = null
            let data = []
            for(let i = 0 ; i < end ; i ++){
                tmp = Object.assign({},result.data[i])
                tmp.status = tmp.status == 1 ? 'พบข้อมูลในการนำส่ง' : 'ไม่พบในการนำส่งข้อมูล'
                tmp.created_at = moment(tmp.created_at).add(543,'Y').format('DD/MM/YYYY')
                data.push(tmp)
            }
            let fields = state.fields
            CsvExport(data, fields, 'จัดเก็บข้อมูลจากเว็บไซต์ผู้ให้บริการ')
            setTimeout(function(){ loadingInstance.close() }, 250);
        }else{
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })        
        }
    },

    async get_provider_list({commit}){
        let result = await Promotion_website_service.get_provider_list()
        if(result.status === 200){
            commit('SET_PROVIDER_LIST',result.data)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })        
        }
    },

    async remove_promotion({commit}, rowdata){
        let result = await Promotion_website_service.remove_promotion({
            promotion_id : rowdata.promotion_id,
            provider_type : rowdata.provider_type
        })
        if(result.status === 200){
            commit('REMOVE_PROMOTION',rowdata.index)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })        
        }
    },

    async fetch_data({commit}, formdata){
        commit('SET_DATA_TABLE', formdata)
    }

};

const mutations = {
    SET_PROVIDER_LIST(state,list){
        state.providers = []
        for(let item of list){
            item.typetag = item.provider_type == 'mobile' ? 'โทรศัพท์เคลื่อนที่' : 'อินเทอร์เน็ตความเร็วสูงประจำที่'
            state.providers.push(item)
        }
    },
    SET_FORM_DOWNLOAD(state, form){
        state.download_form = JSON.parse(JSON.stringify(form))
    },
    SET_STORAGE_DATA(state,data){
        state.promotions = data
        state.total = data.length
        state.data_table = []
        let end = 10 <= data.length ? 10 : data.length
        for(let i = 0 ; i < end ; i ++){
            tmp = Object.assign({},state.promotions[i])
            tmp.status = tmp.status == 1 ? 'พบข้อมูลในการนำส่ง' : 'ไม่พบในการนำส่งข้อมูล'
            tmp.created_at = moment(tmp.created_at).add(543,'Y').format('DD/MM/YYYY')
            tmp.index = i
            state.data_table.push(tmp)
        }
    },
    SET_DATA_TABLE(state,formdata){
        state.loading = true
        state.data_table = []
        if(state.promotions.length){
            let start = (formdata.page-1)*formdata.pageSize
            let end = start+formdata.pageSize-1 < state.promotions.length ? start+formdata.pageSize-1 : state.promotions.length
            let tmp
            for(let i = start ; i < end ; i ++){
                tmp = Object.assign({},state.promotions[i])
                tmp.status = tmp.status == 1 ? 'พบข้อมูลในการนำส่ง' : 'ไม่พบในการนำส่งข้อมูล'
                tmp.created_at = moment(tmp.created_at).add(543,'Y').format('DD/MM/YYYY')
                tmp.index = i
                state.data_table.push(tmp)
            }
        }else{
            state.total = 0
        }
        setTimeout(()=>{
            state.loading = false
        },250)
    },
    SET_LOADING(state,status){
        state.loading = status
    },
    REMOVE_PROMOTION(state,index){
        state.promotions.splice(index, 1)
        let table_index = state.data_table.findIndex(x => x.index == index)
        state.data_table.splice(table_index, 1)
        state.total = state.total - 1
    }
};

let CsvExport = function(data, fields, fileName) {
    try {
      const parser = new Parser({fields});
      const result = parser.parse(data);
      var csvContent = 'data:application/vnd.ms-excel;csvcharset=GBK,\uFEFF' + encodeURIComponent(result)
      var link = document.createElement('a')
      link.setAttribute('href', csvContent)
      link.setAttribute('download', `${(fileName || 'file')}.xls`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (err) {
      console.error(err)
    }
}

export const Promotion_website = {
    namespaced: true,
    state,
    actions,
    mutations
};
